import { render, staticRenderFns } from "./editWhitelist.vue?vue&type=template&id=6e791c9c&scoped=true"
import script from "./editWhitelist.vue?vue&type=script&lang=js"
export * from "./editWhitelist.vue?vue&type=script&lang=js"
import style0 from "./editWhitelist.vue?vue&type=style&index=0&id=6e791c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e791c9c",
  null
  
)

export default component.exports